import React from "react";
import ContentLoader from "react-content-loader";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import LinearProgress from "@material-ui/core/LinearProgress";
import { CheckmarkIcon  } from './Icons';
// const useStyles = makeStyles({
//   root: {
//     width: '100%',
//     color:"rgba(89, 169, 70, 0.4)"
//   },
// });

export default function BuildMyPlanBanner(props) {
  // const classes = useStyles();

  const desktop = useMediaQuery("(min-width:768px)");
  const [progress, setProgress] = React.useState(10);
  const [showSummary, setShowSummary] = React.useState(false);
  
  const BreadcrumbsLoader = () => (
    <ContentLoader style={{ width: "100%" }}>
      <rect x="10" y="110" rx="4" ry="4" width="200" height="10" />
      <rect x="10" y="130" rx="4" ry="4" width="10" height="10" />
      <rect x="35" y="130" rx="4" ry="4" width="50" height="10" />
      <rect x="105" y="130" rx="4" ry="4" width="10" height="10" />
    </ContentLoader>
  );

  const ArrowIcon = () => (
    <svg
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.17016 7.66665C5.03846 7.66662 4.90972 7.62364 4.80023 7.54316C4.69073 7.46268 4.60539 7.3483 4.55499 7.21448C4.5046 7.08067 4.49141 6.93342 4.51709 6.79137C4.54278 6.64931 4.60619 6.51882 4.6993 6.41638L6.89243 4.00448L4.6993 1.59258C4.63569 1.52501 4.58495 1.44419 4.55005 1.35483C4.51514 1.26547 4.49677 1.16936 4.496 1.07211C4.49524 0.974859 4.51209 0.878412 4.54557 0.788399C4.57906 0.698385 4.62851 0.616608 4.69105 0.547838C4.75358 0.479067 4.82794 0.424682 4.90979 0.387855C4.99163 0.351027 5.07933 0.332496 5.16776 0.333341C5.25619 0.334186 5.34359 0.354391 5.42484 0.392777C5.50609 0.431163 5.57958 0.486962 5.64102 0.556916L8.30501 3.48665C8.42986 3.624 8.5 3.81026 8.5 4.00448C8.5 4.19869 8.42986 4.38496 8.30501 4.52231L5.64102 7.45204C5.51615 7.58941 5.34678 7.6666 5.17016 7.66665Z"
        fill="#D9D9D9"
      />
      <path
        d="M1.17418 7.66665C1.04248 7.66662 0.913743 7.62364 0.804247 7.54316C0.694751 7.46268 0.60941 7.3483 0.559014 7.21448C0.508618 7.08067 0.495429 6.93342 0.521115 6.79137C0.546801 6.64931 0.610208 6.51882 0.703321 6.41638L2.89645 4.00448L0.703321 1.59258C0.639712 1.52501 0.588974 1.44419 0.55407 1.35483C0.519166 1.26547 0.500794 1.16936 0.500025 1.07211C0.499257 0.974859 0.516107 0.878412 0.549594 0.788399C0.583081 0.698385 0.632534 0.616608 0.695066 0.547838C0.757598 0.479067 0.831958 0.424682 0.913806 0.387855C0.995655 0.351027 1.08335 0.332496 1.17178 0.333341C1.26021 0.334186 1.34761 0.354391 1.42886 0.392777C1.51011 0.431163 1.5836 0.486962 1.64504 0.556916L4.30903 3.48665C4.43388 3.624 4.50402 3.81026 4.50402 4.00448C4.50402 4.19869 4.43388 4.38496 4.30903 4.52231L1.64504 7.45204C1.52017 7.58941 1.3508 7.6666 1.17418 7.66665Z"
        fill="#D9D9D9"
      />
    </svg>
  );

  const ArrowIconDown = () => (
    <svg 
      width="8" 
      height="9" 
      viewBox="0 0 8 9" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M0.33317 5.17016C0.333201 5.03846 0.376174 4.90972 0.456657 4.80023C0.53714 4.69073 0.651519 4.60539 0.785335 4.55499C0.919151 4.5046 1.06639 4.49141 1.20845 4.51709C1.35051 4.54278 1.481 4.60619 1.58343 4.6993L3.99534 6.89243L6.40724 4.6993C6.4748 4.63569 6.55562 4.58495 6.64498 4.55005C6.73434 4.51514 6.83045 4.49677 6.92771 4.496C7.02496 4.49524 7.1214 4.51209 7.21142 4.54557C7.30143 4.57906 7.38321 4.62851 7.45198 4.69105C7.52075 4.75358 7.57513 4.82794 7.61196 4.90979C7.64879 4.99163 7.66732 5.07933 7.66648 5.16776C7.66563 5.25619 7.64543 5.34359 7.60704 5.42484C7.56865 5.50609 7.51286 5.57958 7.4429 5.64102L4.51317 8.30501C4.37582 8.42986 4.18955 8.5 3.99534 8.5C3.80112 8.5 3.61486 8.42986 3.47751 8.30501L0.547773 5.64102C0.410405 5.51615 0.333212 5.34678 0.33317 5.17016Z" 
        fill="#468537"
      />
      <path 
        d="M0.33317 1.17418C0.333201 1.04248 0.376174 0.913743 0.456657 0.804247C0.53714 0.69475 0.651519 0.60941 0.785335 0.559014C0.919151 0.508618 1.06639 0.495429 1.20845 0.521115C1.35051 0.546801 1.481 0.610208 1.58343 0.703321L3.99534 2.89645L6.40724 0.703321C6.4748 0.639712 6.55562 0.588974 6.64498 0.55407C6.73434 0.519166 6.83045 0.500794 6.92771 0.500025C7.02496 0.499257 7.1214 0.516107 7.21142 0.549594C7.30143 0.583081 7.38321 0.632534 7.45198 0.695066C7.52075 0.757598 7.57513 0.831958 7.61196 0.913806C7.64879 0.995655 7.66732 1.08335 7.66648 1.17178C7.66563 1.26021 7.64543 1.34761 7.60704 1.42886C7.56865 1.51011 7.51286 1.5836 7.4429 1.64504L4.51317 4.30903C4.37582 4.43388 4.18955 4.50402 3.99534 4.50402C3.80112 4.50402 3.61486 4.43388 3.47751 4.30903L0.547773 1.64504C0.410405 1.52017 0.333212 1.3508 0.33317 1.17418Z" 
        fill="#468537"
      />
    </svg>
  );

  const handleSummaryChange = () => {
    const newValue = !showSummary;
    if (props.setShowSummary) {
      props.setShowSummary(newValue);
    }
    setShowSummary(newValue);
  };
  
  const BreadcrumbsDiv = () => {
    
    //console.log('Test: ' + props.title);

    switch (props.title) {
      case "Find My Price":
        return (
          <>
            <Breadcrumbs separator={<ArrowIcon />}>
              <span
                className="active label-navigation"
                style={{ zIndex: "9" }}
              >
                <label className="circle">1</label> Find <legend className="mobile-hide">My</legend> Price
              </span>
              <span className="whitenav label-navigation">
                <label className="circle">2</label> Choose <legend className="mobile-hide">Your</legend> Plan
              </span>
              <span className="whitenav label-navigation">
                <label className="circle">3</label> Build Your Plan
              </span>
              <span className="whitenav label-navigation">
                <label className="circle">4</label> Your Details
              </span>
            </Breadcrumbs>
            <div className="mobile-show">
              <div className="title-banner" onClick={handleSummaryChange}>
                <ArrowIconDown /> 
                <span className="title-banner__label">{showSummary ? 'Close Summary' : 'Plan Summary'}</span>
                <ArrowIconDown /> 
              </div>
            </div>
          </>
        );
        case "Choose Your Plan":
          return (
            <>
              <Breadcrumbs separator={<ArrowIcon />}>
                <span
                  className="whitenav label-navigation prev-nav"
                >
                  <label className="circle-prev"><CheckmarkIcon /></label> Find <legend className="mobile-hide">My</legend> Price
                </span>
                <span className="active label-navigation"
                  style={{ zIndex: "9" }}>
                  <label className="circle">2</label> Choose <legend className="mobile-hide">Your</legend> Plan
                </span>
                <span className="whitenav label-navigation">
                  <label className="circle">3</label> Build Your Plan
                </span>
                <span className="whitenav label-navigation">
                  <label className="circle">4</label> Your Details
                </span>
              </Breadcrumbs>
              <div className="mobile-show">
                <div className="title-banner" onClick={handleSummaryChange}>
                  <ArrowIconDown /> 
                  <span className="title-banner__label">{showSummary ? 'Close Summary' : 'Plan Summary'}</span>
                  <ArrowIconDown /> 
                </div>
              </div>
            </>
          );
      case "Build Your Plan":
        return (
          <>
            <Breadcrumbs separator={<ArrowIcon />}>
              <span
                className="whitenav label-navigation prev-nav"
              >
                <label className="circle-prev"><CheckmarkIcon /></label> Find <legend className="mobile-hide">My</legend> Price
              </span>
              <span className="whitenav label-navigation prev-nav"
                style={{ zIndex: "9" }}>
                <label className="circle-prev"><CheckmarkIcon /></label> Choose <legend className="mobile-hide">Your</legend> Plan
              </span>
              <span className="active label-navigation">
                <label className="circle">3</label> Build Your Plan
              </span>
              <span className="whitenav label-navigation">
                <label className="circle">4</label> Your Details
              </span>
            </Breadcrumbs>
            <div className="mobile-show">
              <div className="title-banner" onClick={handleSummaryChange}>
                <ArrowIconDown /> 
                <span className="title-banner__label">{showSummary ? 'Close Summary' : 'Plan Summary'}</span>
                <ArrowIconDown /> 
              </div>
            </div>
          </>
        );
      case "Your Details":
        return (
          <>
            <Breadcrumbs separator={<ArrowIcon />}>
              <span
                className="whitenav label-navigation prev-nav"
              >
                <label className="circle-prev"><CheckmarkIcon /></label> Find <legend className="mobile-hide">My</legend> Price
              </span>
              <span className="whitenav label-navigation prev-nav"
                style={{ zIndex: "9" }}>
                <label className="circle-prev"><CheckmarkIcon /></label> Choose <legend className="mobile-hide">Your</legend> Plan
              </span>
              <span className="whitenav label-navigation prev-nav">
                <label className="circle-prev"><CheckmarkIcon /></label> Build Your Plan
              </span>
              <span className="active label-navigation">
                <label className="circle">4</label> Your Details
              </span>
            </Breadcrumbs>
            <div className="mobile-show">
              <div className="title-banner" onClick={handleSummaryChange}>
                <ArrowIconDown />
                <span className="title-banner__label">{showSummary ? 'Close Summary' : 'Plan Summary'}</span>
                <ArrowIconDown />
              </div>
            </div>
          </>
        );
      default:
        return "";
    }
  };
  // const BreadcrumbsDiv = (title) => (

  // );

  React.useEffect(() => {
    if (props.step !== undefined && props.step < 10) {
      setProgress(props.step * 10);
    } else if (props.step === 10) {
      setProgress(95);
    } else {
      setProgress(100);
    }
  }, [props.step]);
  return (
    <React.Fragment>
      {/* <div className="container-fluid" id="banner">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {props.isLoading ? (
                <h2>
                  <TitleLoader />
                </h2>
              ) : (
                <h2>{props.title}</h2>
              )}
            </div>
          </div>
        </div>
      </div> */}
      <div
        className="breadcrumbsContainer"
        id={
          props.id !== "declined" &&
          props.id !== "pending" &&
          props.id !== "success"
            ? "breadcrumbsDiv"
            : "noBreadcrumbsDiv"
        }
      >
        {props.id !== "declined" && (
          <div>
              {props.isLoading && desktop ? (
                <h4>
                  <BreadcrumbsLoader />
                </h4>
              ) : (
                <div
                  id={desktop ? "desktop-breadcrumbs" : "mobile-breadcrumbs"}
                >
                  {BreadcrumbsDiv()}
                </div>
              )}
          </div>
        )}
      </div>
      {!desktop && props.id !== "declined" && props.id !== "pending" && (
        <LinearProgress variant="determinate" value={progress} />
      )}
    </React.Fragment>
  );
}
